import type { CMYKColor } from "@pdfking/math"
import { ToCmyk } from "@pdfking/math"
import type { ColorID } from "@pdfking/renderer-api"

import type { Palette } from "#internal"

// straight from its file: #internal imports these constants
import { Hex } from "../internal/colors/Hex"

/** Bauhaus on white: black text, yellow and blue; the lines black at 30%, as
 * the shop's notepad templates rule them. The spot prints nothing: its
 * elements are only on the spot plate (see `InkPalette`). */
export const Default: Palette = {
  lines: { alpha: 1, black: 0.3, cyan: 0, magenta: 0, yellow: 0 } as CMYKColor,
  paper: ToCmyk(Hex("#ffffff")),
  primary: ToCmyk(Hex("#f2c230")),
  secondary: ToCmyk(Hex("#1c3f94")),
  spot: ToCmyk(Hex("#000000", 0)),
  text: ToCmyk(Hex("#1a1a1a")),
}

// The palette's colors as shapes name them: the plot's color map holds each
// under its own name (see InkPalette)
export const PALETTE = {
  lines: "lines",
  paper: "paper",
  primary: "primary",
  secondary: "secondary",
  spot: "spot",
  text: "text",
} as Record<keyof Palette, ColorID>
